module.exports = __webpack_public_path__ + "2e5e771ddc5f640df620c595c69007ae.svg";